/* ---------- shared: photo carousel with lightbox (same behaviour as the live carousel) ---------- */
function dmlGallery(root){
  var track=root.querySelector('.gal-track'), items=[].slice.call(root.querySelectorAll('.gal-item'));
  var bar=root.querySelector('.gal-progress i'), count=root.querySelector('.gal-count');
  var prev=root.querySelector('.gal-prev'), next=root.querySelector('.gal-next');
  /* each plate keeps the photograph's own shape (clamped), read from the image once it loads */
  items.forEach(function(it){
    var im=it.querySelector('img');
    function ar(){ if(im.naturalWidth){ var r=Math.max(.66,Math.min(1.6,im.naturalWidth/im.naturalHeight)); it.style.setProperty('--ar',r.toFixed(3)); update(); } }
    if(im.complete) ar(); else im.addEventListener('load',ar);
  });
  function current(){
    var left=track.getBoundingClientRect().left+parseFloat(getComputedStyle(track).scrollPaddingLeft||0), best=0, bd=1e9;
    items.forEach(function(it,i){ var d=Math.abs(it.getBoundingClientRect().left-left); if(d<bd){bd=d;best=i;} });
    return best;
  }
  function update(){
    var max=track.scrollWidth-track.clientWidth, vis=Math.min(1,track.clientWidth/track.scrollWidth), f=max>0?track.scrollLeft/max:0;
    bar.style.width=(vis*100)+'%'; bar.style.left=(f*(1-vis)*100)+'%';
    var i=max>0&&track.scrollLeft>=max-2?items.length-1:current();
    count.textContent=(i+1)+' / '+items.length;
    prev.disabled=track.scrollLeft<=2; next.disabled=track.scrollLeft>=max-2;
  }
  var raf=0; track.addEventListener('scroll',function(){ if(!raf) raf=requestAnimationFrame(function(){raf=0;update();}); },{passive:true});
  window.addEventListener('resize',update);
  var target=-1,tt=0;
  function go(d){
    var i=Math.max(0,Math.min(items.length-1,(target>=0?target:current())+d)); target=i; clearTimeout(tt); tt=setTimeout(function(){target=-1;},700);
    track.scrollTo({left:items[i].offsetLeft-parseFloat(getComputedStyle(track).scrollPaddingLeft||0),behavior:'smooth'});
  }
  prev.addEventListener('click',function(){go(-1)}); next.addEventListener('click',function(){go(1)});
  /* drag with a mouse */
  var down=false,moved=false,sx=0,sl=0;
  track.addEventListener('pointerdown',function(e){ if(e.pointerType!=='mouse'||e.button!==0) return; down=true;moved=false;sx=e.clientX;sl=track.scrollLeft; });
  window.addEventListener('pointermove',function(e){ if(!down) return; var dx=e.clientX-sx; if(!moved&&Math.abs(dx)>6){moved=true;track.classList.add('drag');} if(moved) track.scrollLeft=sl-dx; });
  window.addEventListener('pointerup',function(){ if(!down) return; down=false; if(moved){ track.classList.remove('drag'); setTimeout(function(){moved=false;},0);} });
  /* lightbox */
  var lb=document.createElement('div'); lb.className='lb'; lb.setAttribute('role','dialog'); lb.setAttribute('aria-modal','true');
  lb.innerHTML='<button class="x sc" type="button">'+(window.DML_T&&DML_T.close||'Close')+'</button><button class="pv" type="button" aria-label="Previous">&#8592;</button><button class="nx" type="button" aria-label="Next">&#8594;</button><img alt=""><p></p>';
  var lbHost=document.createElement('div'); lbHost.className='dml-book dml-layer'; lbHost.appendChild(lb); document.body.appendChild(lbHost);
  var li=lb.querySelector('img'), lp=lb.querySelector('p'), idx=0;
  function show(i){ idx=(i+items.length)%items.length; var it=items[idx], im=it.querySelector('img'); li.src=im.src.replace(/width=\d+/,'width=2000'); li.alt=im.alt; lp.innerHTML=it.querySelector('.cap').innerHTML; }
  function close(){ lb.classList.remove('open'); document.documentElement.style.overflow=''; }
  items.forEach(function(it,i){ it.addEventListener('click',function(e){ if(moved){e.preventDefault();return;} show(i); lb.classList.add('open'); document.documentElement.style.overflow='hidden'; }); });
  lb.querySelector('.x').addEventListener('click',close);
  lb.querySelector('.pv').addEventListener('click',function(){show(idx-1)}); lb.querySelector('.nx').addEventListener('click',function(){show(idx+1)});
  lb.addEventListener('click',function(e){ if(e.target===lb) close(); });
  document.addEventListener('keydown',function(e){ if(!lb.classList.contains('open')) return; if(e.key==='Escape')close(); if(e.key==='ArrowRight')show(idx+1); if(e.key==='ArrowLeft')show(idx-1); });
  var tx=null; lb.addEventListener('touchstart',function(e){tx=e.touches[0].clientX},{passive:true});
  lb.addEventListener('touchend',function(e){ if(tx===null)return; var dx=e.changedTouches[0].clientX-tx; tx=null; if(Math.abs(dx)>45) show(idx+(dx<0?1:-1)); });
  update();
}
/* ---------- shared: custom dropdown (listbox) ---------- */
function dmlDrop(root,opts,val,onChange){
  var id='dd'+Math.random().toString(36).slice(2,8), label=root.getAttribute('data-label')||'';
  root.classList.add('dd');
  root.innerHTML='<button type="button" class="dd-btn" aria-haspopup="listbox" aria-expanded="false" aria-controls="'+id+'"><span class="dd-val"></span>'+
    '<svg viewBox="0 0 11 7" aria-hidden="true"><path d="M1 1l4.5 4.5L10 1" fill="none" stroke="currentColor" stroke-width="1.1"/></svg></button>'+
    '<ul class="dd-list" role="listbox" id="'+id+'" tabindex="-1"'+(label?' aria-label="'+label+'"':'')+'>'+
    opts.map(function(o,i){return '<li class="dd-opt" role="option" id="'+id+'-'+i+'" data-v="'+o.v+'">'+(o.d?'<span class="tw"><span class="t">'+o.t+'</span><span class="d">'+o.d+'</span></span>':'<span class="t">'+o.t+'</span>')+(o.s?'<span class="s sc">'+o.s+'</span>':'')+'</li>'}).join('')+'</ul>';
  var btn=root.querySelector('.dd-btn'), list=root.querySelector('.dd-list'), items=[].slice.call(root.querySelectorAll('.dd-opt')), cur=val, act=0;
  function idx(v){ for(var i=0;i<opts.length;i++) if(opts[i].v===v) return i; return 0; }
  function set(v,fire){ cur=v; var o=opts[idx(v)]; items.forEach(function(li){li.setAttribute('aria-selected',li.dataset.v===v)});
    root.querySelector('.dd-val').textContent=o.short||o.t; btn.setAttribute('aria-label',(label?label+': ':'')+o.t); if(fire&&onChange) onChange(v); }
  function hl(){ items.forEach(function(li,i){li.classList.toggle('act',i===act)}); list.setAttribute('aria-activedescendant',items[act].id); }
  function isOpen(){ return root.hasAttribute('data-open'); }
  function open(){ root.setAttribute('data-open',''); btn.setAttribute('aria-expanded','true'); act=idx(cur); hl(); list.focus({preventScroll:true}); }
  function close(refocus){ if(!isOpen()) return; root.removeAttribute('data-open'); btn.setAttribute('aria-expanded','false'); if(refocus) btn.focus({preventScroll:true}); }
  btn.addEventListener('click',function(){ isOpen()?close(true):open(); });
  btn.addEventListener('keydown',function(e){ if(e.key==='ArrowDown'||e.key==='ArrowUp'){ e.preventDefault(); open(); } });
  items.forEach(function(li,i){
    li.addEventListener('mousemove',function(){ if(act!==i){act=i;hl();} });
    li.addEventListener('click',function(){ set(li.dataset.v,true); close(true); });
  });
  list.addEventListener('keydown',function(e){
    if(e.key==='ArrowDown'){ e.preventDefault(); act=Math.min(items.length-1,act+1); hl(); }
    else if(e.key==='ArrowUp'){ e.preventDefault(); act=Math.max(0,act-1); hl(); }
    else if(e.key==='Home'){ e.preventDefault(); act=0; hl(); }
    else if(e.key==='End'){ e.preventDefault(); act=items.length-1; hl(); }
    else if(e.key==='Enter'||e.key===' '){ e.preventDefault(); set(items[act].dataset.v,true); close(true); }
    else if(e.key==='Escape'){ e.preventDefault(); close(true); }
    else if(e.key==='Tab'){ close(false); }
  });
  document.addEventListener('click',function(e){ if(!root.contains(e.target)) close(false); });
  set(val);
  return { get:function(){return cur}, set:function(v){set(v)} };
}
/* ---------- shared: shrink the letter text until it fits its sheet ---------- */
function dmlFit(w,b){ b.style.fontSize=''; var base=parseFloat(getComputedStyle(b).fontSize); if(!base||w.scrollHeight<=w.clientHeight+2) return;
  var lo=.25,hi=1; for(var k=0;k<12;k++){var m=(lo+hi)/2; b.style.fontSize=(base*m)+'px'; if(w.scrollHeight<=w.clientHeight+2) lo=m; else hi=m;} b.style.fontSize=(base*lo)+'px'; }
/* ---------- shared: read a letter full size ---------- */
var dmlReader=(function(){
  var el=null, prev=null;
  function build(){
    el=document.createElement('div'); el.className='reader'; el.setAttribute('role','dialog'); el.setAttribute('aria-modal','true'); el.setAttribute('aria-label','The letter, full size');
    el.innerHTML='<button type="button" class="x">'+(window.DML_T&&DML_T.close||'Close')+'</button><div class="sheet"><p class="ttl"></p><div class="ltr"><div class="ltr-wrap"><div class="ltr-body"></div></div></div></div>';
    var host=document.createElement('div'); host.className='dml-book dml-layer'; host.appendChild(el); document.body.appendChild(host);
    el.querySelector('.x').addEventListener('click',close);
    el.addEventListener('click',function(e){ if(e.target===el) close(); });
    document.addEventListener('keydown',function(e){ if(e.key==='Escape'&&el.classList.contains('open')) close(); });
  }
  function close(){ el.classList.remove('open'); document.documentElement.style.overflow=''; if(prev) prev.focus({preventScroll:true}); }
  /* content: the letter's HTML, or {env:true,bg,name,addr} for the envelope */
  return function(content,title){
    if(!el) build(); prev=document.activeElement;
    var sheet=el.querySelector('.sheet'), isEnv=typeof content==='object';
    el.querySelector('.ttl').textContent=title||'';
    sheet.classList.toggle('wide',isEnv);
    el.querySelector('.ltr').hidden=isEnv;
    var ev=sheet.querySelector('.env'); if(ev) ev.remove();
    if(isEnv){ ev=document.createElement('div'); ev.className='env'; ev.style.backgroundImage="url('"+content.bg+"')";
      ev.innerHTML='<div class="env-text"><div class="env-name">'+content.name+'</div><div class="env-addr">'+content.addr+'</div></div>'; sheet.appendChild(ev); }
    else el.querySelector('.ltr-body').innerHTML=content;
    el.classList.add('open'); document.documentElement.style.overflow='hidden'; el.scrollTop=0;
    if(!isEnv) requestAnimationFrame(function(){ dmlFit(el.querySelector('.ltr-wrap'),el.querySelector('.ltr-body')); });
    el.querySelector('.x').focus({preventScroll:true});
  };
})();
/* ---------- shared: sticky call to action on phones ---------- */
function dmlSticky(bar,after,hide){
  if(!bar||!('IntersectionObserver' in window)) return;
  var past=false, hidden=false, hs={};
  function upd(){ bar.classList.toggle('show',past&&!hidden); }
  new IntersectionObserver(function(es){ es.forEach(function(e){ past=!e.isIntersecting&&e.boundingClientRect.top<0; }); upd(); }).observe(after);
  var io=new IntersectionObserver(function(es){ es.forEach(function(e){ hs[e.target.dataset.sk]=e.isIntersecting; }); hidden=Object.keys(hs).some(function(k){return hs[k]}); upd(); });
  hide.forEach(function(h,i){ if(h){ h.dataset.sk=i; io.observe(h); } });
}
/* ======================================================================
   DML book: section behaviours. Each section root carries data-dml="<name>"
   and, when it needs data, a <script type="application/json" class="dml-data">.
   Runs on page load and again when a section is re-rendered in the theme editor.
   ====================================================================== */
var DML=window.DML||{};
DML.data=function(root){ var s=root.querySelector('script.dml-data'); try{ return s?JSON.parse(s.textContent):{}; }catch(e){ return {}; } };
DML.esc=function(t){ return String(t).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]}); };
DML.link=function(base,p){ var q=new URLSearchParams(p).toString(); var h=''; var i=base.indexOf('#'); if(i>-1){ h=base.slice(i); base=base.slice(0,i); } return base+(q?(base.indexOf('?')===-1?'?':'&')+q:'')+(h||'#builder'); };
/* the story list: from the stories section when it is on the page, otherwise from the section asking */
DML.stories=function(fallback){
  var s=document.getElementById('dml-stories-json');
  if(s){ try{ var d=JSON.parse(s.textContent); if(d&&d.length) return d; }catch(e){} }
  return fallback||[];
};
DML.letterHTML=function(L,s,name,blank){
  var nm=name?'<mark>'+DML.esc(name)+'</mark>':(blank?'<span class="ph">___</span>':'<mark>'+DML.esc(L.sample||'Elliott')+'</mark>');
  var paras=(L.letters[s.template]||[]).map(function(p){return p.split('@@NAME@@').join(nm)}).concat([L.signature]);
  if(L.lang==='french') paras=paras.map(function(p){return p.replace(/ ([!?:;»])/g,' $1').replace(/« /g,'« ')});
  return paras.map(function(p){return '<p>'+p+'</p>'}).join('');
};

DML.init={
  /* ---------- masthead: language, mobile drawer ---------- */
  masthead:function(root){
    var d=DML.data(root), form=root.querySelector('form.dml-loc'), input=form&&form.querySelector('input[name="language_code"]');
    function go(v){ if(!form||!input||v===d.current) return; input.value=v; form.submit(); }
    var lang=root.querySelector('.dd-lang');
    if(lang&&d.langs&&d.langs.length>1) dmlDrop(lang,d.langs,d.current,go);
    var burger=root.querySelector('.burger'), drawer=root.querySelector('.mdrawer');
    if(drawer&&burger){
      burger.addEventListener('click',function(){ var o=drawer.hidden; drawer.hidden=!o; burger.setAttribute('aria-expanded',o); });
      drawer.querySelectorAll('a').forEach(function(a){ a.addEventListener('click',function(){ drawer.hidden=true; burger.setAttribute('aria-expanded','false'); }); });
      drawer.querySelectorAll('.langs button').forEach(function(b){ b.addEventListener('click',function(){ go(b.dataset.v); }); });
    }
  },

  /* ---------- banner: the sticky call to action on phones ---------- */
  banner:function(root){
    var bar=root.querySelector('.stickybar'); if(!bar) return;
    var hide=[document.getElementById('try'),document.querySelector('[data-dml="invitation"]'),document.querySelector('.imprint')];
    dmlSticky(bar,root.querySelector('.banner'),hide);
  },

  /* ---------- I. the live teaser ---------- */
  teaser:function(root){
    var d=DML.data(root), L=d.L||{letters:{},signature:'',address:''}; L.lang=d.lang;
    var STORIES=DML.stories(d.stories);
    var $=function(c){return root.querySelector(c)};
    var nameI=$('.tz-name'), addrI=$('.tz-addr'), colour='sapphire', go=$('.tz-go'), env=$('.env');
    if(!nameI||!STORIES.length) return;
    function find(v){ for(var i=0;i<STORIES.length;i++) if(STORIES[i].id===v) return STORIES[i]; return STORIES[0]; }
    var story=dmlDrop($('.tz-story'),STORIES.map(function(s){return {v:s.id,t:s.title,s:s.who}}),STORIES[0].id,function(v){ setColour(find(v).colour); render(); });
    function setColour(c){ colour=c; root.querySelectorAll('.swch').forEach(function(b){b.setAttribute('aria-pressed',b.dataset.c===c)}); env.style.backgroundImage="url('"+d.envelopes[c]+"')"; updateLink(); }
    function fit(){ dmlFit($('.ltr-wrap'),$('.ltr-body')); }
    function updateLink(){ var s=find(story.get()); var q={dml_story:s.template,dml_colour:colour,dml_lang:d.lang}; if(nameI.value.trim())q.dml_name=nameI.value.trim(); if(addrI.value.trim())q.dml_address=addrI.value.trim(); go.href=DML.link(d.builder,q); }
    function render(){
      var raw=nameI.value.trim(), a=addrI.value.trim();
      $('.env-name').innerHTML=raw?DML.esc(raw):'<span style="opacity:.8">'+DML.esc(d.t.envName)+'</span>';
      $('.env-addr').innerHTML='<span'+(a?'':' style="opacity:.8"')+'>'+DML.esc(a||L.address)+'</span>';
      var s=find(story.get());
      if(s.template==='write-your-own') $('.ltr-body').innerHTML='<p><span class="ph" style="font-size:.6em">'+DML.esc(d.t.wyo)+'</span></p>';
      else $('.ltr-body').innerHTML=DML.letterHTML(L,s,raw,true);
      requestAnimationFrame(fit); updateLink();
    }
    nameI.addEventListener('input',render); addrI.addEventListener('input',render);
    root.querySelectorAll('.swch').forEach(function(b){b.addEventListener('click',function(){setColour(b.dataset.c)})});
    window.addEventListener('resize',function(){requestAnimationFrame(fit)});
    if(document.fonts&&document.fonts.ready) document.fonts.ready.then(fit);
    setColour(STORIES[0].colour||'sapphire'); render();
    function mode(santa){
      $('.tab-tf').setAttribute('aria-selected',!santa); $('.tab-santa').setAttribute('aria-selected',santa);
      $('.tf-side').hidden=santa; $('.stage').hidden=santa; $('.santa-side').hidden=!santa; $('.santa-card').hidden=!santa;
    }
    $('.tab-tf').addEventListener('click',function(){mode(false)}); $('.tab-santa').addEventListener('click',function(){mode(true)});
    DML.openSanta=function(){ mode(true); };
    if(document.querySelector('#dml-santa-teaser .notify-ok')) mode(true);
    $('.tz-read').addEventListener('click',function(){ var s=find(story.get()); dmlReader($('.ltr-body').innerHTML,s.title+(nameI.value.trim()?' · '+nameI.value.trim():'')); });
  },

  /* ---------- II. the six stories ---------- */
  stories:function(root){
    var d=DML.data(root), L=d.L||{letters:{},signature:''}; L.lang=d.lang;
    var STORIES=DML.stories([]);
    root.querySelectorAll('.story').forEach(function(card){
      var s=null; for(var i=0;i<STORIES.length;i++) if(STORIES[i].id===card.dataset.id) s=STORIES[i];
      if(!s) return;
      card.querySelectorAll('a.story-link,a.more').forEach(function(a){ a.href=DML.link(d.builder,{dml_story:s.template,dml_colour:s.colour,dml_lang:d.lang}); });
      var rb=card.querySelector('[data-read]');
      if(rb) rb.addEventListener('click',function(){ dmlReader(DML.letterHTML(L,s),s.title); });
    });
    if(window.matchMedia('(hover: none)').matches && 'IntersectionObserver' in window){
      var io=new IntersectionObserver(function(es){es.forEach(function(e){e.target.classList.toggle('is-open',e.isIntersecting)})},{rootMargin:'-42% 0px -42% 0px'});
      root.querySelectorAll('.story').forEach(function(c){io.observe(c)});
    }
  },

  /* ---------- III. community films: play on screen, one with sound at a time ---------- */
  community:function(root){
    var d=DML.data(root);
    var vids=[].slice.call(root.querySelectorAll('.reel video'));
    if('IntersectionObserver' in window){ var vio=new IntersectionObserver(function(es){es.forEach(function(e){ if(e.isIntersecting){var p=e.target.play(); if(p&&p.catch)p.catch(function(){});} else e.target.pause(); })},{threshold:.2}); vids.forEach(function(v){v.muted=true;vio.observe(v)}); }
    var btns=[].slice.call(root.querySelectorAll('.snd'));
    btns.forEach(function(b){ b.addEventListener('click',function(){
      var v=b.parentNode.querySelector('video'), on=v.muted;
      vids.forEach(function(o){o.muted=true}); btns.forEach(function(x){x.setAttribute('aria-pressed','false');x.setAttribute('aria-label',d.soundOn||'Turn sound on')});
      if(on){ v.muted=false; b.setAttribute('aria-pressed','true'); b.setAttribute('aria-label',d.soundOff||'Turn sound off'); var p=v.play(); if(p&&p.catch)p.catch(function(){}); }
    }); });
  },

  /* ---------- IV. photographed in our studio ---------- */
  studio:function(root){ var g=root.querySelector('.gal'); if(g&&g.querySelector('.gal-item')) dmlGallery(g); }
};

/* ---------- the Santa register: Shopify customer forms tagged santa-waitlist, posted in the background ---------- */
DML.waitlist=function(scope){
  if(!window.fetch||!window.FormData) return;
  scope.querySelectorAll('form.dml-waitlist').forEach(function(f){
    if(f.dataset.bound) return; f.dataset.bound='1';
    f.addEventListener('submit',function(e){
      if(!f.querySelector('input[type="email"]')) return;
      e.preventDefault();
      var btn=f.querySelector('button[type="submit"]'); if(btn){btn.disabled=true;}
      fetch(f.action,{method:'POST',body:new FormData(f),credentials:'same-origin'})
        .then(function(r){
          if(!(r.ok && /customer_posted=true/.test(r.url))) throw new Error('fallback');
          var p=document.createElement('p'); p.className='register-ok'; p.setAttribute('role','status'); p.textContent=f.dataset.ok||'';
          f.replaceWith(p);
        })
        .catch(function(){ HTMLFormElement.prototype.submit.call(f); });
    });
  });
};

DML.run=function(scope){
  scope=scope||document;
  var list=[].slice.call(scope.querySelectorAll('[data-dml]'));
  if(scope.matches&&scope.matches('[data-dml]')) list.unshift(scope);
  list.forEach(function(r){ var f=DML.init[r.dataset.dml]; if(f){ try{ f(r); }catch(err){ if(window.console) console.error('[DML]',r.dataset.dml,err); } } });
  DML.waitlist(scope);
};
/* links to #santa-letters (the menu) land on the North Pole section */
DML.hash=function(){
  if(location.hash==='#santa-letters'||location.hash==='#dml-santa-notify'){ var t=document.getElementById('santa'); if(t) setTimeout(function(){t.scrollIntoView({behavior:'smooth'})},250); }
};
window.DML=DML;
if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',function(){DML.run(document);DML.hash();}); else { DML.run(document); DML.hash(); }
document.addEventListener('shopify:section:load',function(e){ DML.run(e.target); });
